module.exports = "/assets/js/75033362845801c4d28f9fb3c42442e8.svg";